import injectSheet from 'react-jss'
import ContextMenu from './ContextMenu'
import styles from './ContextMenu.styles'

export default injectSheet(styles)(ContextMenu)
